import type { Level } from ".";
import { Transport } from "./transport";

const ConsoleColor = {
  Reset: "\x1b[0m",
  FgRed: "\x1b[31m",
  FgGreen: "\x1b[32m",
  FgYellow: "\x1b[33m",
  FgBlue: "\x1b[34m",
};

const LevelColorMapper: Record<Level, string> = {
  warn: ConsoleColor.FgYellow,
  info: ConsoleColor.FgGreen,
  error: ConsoleColor.FgRed,
  debug: ConsoleColor.FgBlue,
};

export class ConsoleTransport extends Transport {
  send(level: Level, message: string, meta: Record<string, unknown>) {
    console.log(
      `${LevelColorMapper[level]} ${level}: \t ${message} ${meta ? JSON.stringify(meta, null, 2) : ""} ${
        ConsoleColor.Reset
      }`
    );
  }
}
